export default "__VITE_ASSET__CzyIHMZe__"